import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import _ from "lodash";
import config from "../../config";
import docTypeFields from "../../models/DocTypeFields";

const fetchMenuItems = () => {
    return axios.get(`/method/restaurant_management.api.get_menu_items`);
};

const fetchAddons = () => {
    const params = {
        fields: JSON.stringify(docTypeFields.Addon),
        filters: JSON.stringify([["disabled", "=", 0]]),
        // filters: JSON.stringify([["item_type", "=", "Addons"], ["disabled", "=", 0]]),
        limit: 0, // Set the limit to 0 to load all items
    };

    return axios.get(`/resource/Item`, { params });
};

export const useItems = (onSuccess, onError) => {
    return useQuery(
        ["getMenuItems"],
        async () => {
            const data = await fetchMenuItems();
            return data.data.message;
        },
        {
            select: transformMenuItems,
            onSuccess,
            onError,
            cacheTime: 30 * 1000 * 60 * 60 * 24,
        }
    );
};

export const useAddons = (onSuccess, onError) => {
    return useQuery(
        ["getAddons"],
        async () => {
            let data = await fetchAddons();
            return data.data.data;
        },
        {
            onSuccess,
            onError,
        }
    );
};

const transformMenuItems = (data) => {
    const items = _.filter(data, { item_type: "Menu" });
    const convertedItems = items.map((item) => ({
        ...item,
        id: item.item_code,
        identifier: item.item_code,
        name: item.item_code,
        item_code: item.item_code,
        cover: `${config.baseUrl}${item.image}`,
        colors: ["#00AB55"],
        standard_rate: item.standard_rate,
        item_group: item.item_group,
        pos_qty: 0,
        rate: 0,
        price_list_rate: 0,
        discount_percentage: 0,
        item_tax_template: "",
        item_tax_rate: "{}",
        status: "Attending",
        has_serial_no: 0,
        serial_no: "",
        has_batch_no: 0,
        batch_no: "",
        notes: "",
        projected_qty: item.projected_qty,
        allowed_addons: item.allowed_addons
            ? JSON.parse(item.allowed_addons)
            : [],
    }));

    return convertedItems;
};

const fetchGroups = () => {
    let params = {
        fields: JSON.stringify(docTypeFields.ItemGroup),
        limit: 0, // Set the limit to 0 to load all items
    };
    return axios.get(`/resource/Item Group`, { params });
};

export const useItemGroups = (onSuccess, onError) => {
    return useQuery(
        ["getItemGroups"],
        async () => {
            const data = await fetchGroups();

            const groups = _.remove(data.data.data, function (element) {
                return element.showpos === 1;
            });

            const convertedGroups = [...groups].map((_, index) => ({
                id: groups[index].item_group_name,
                name: groups[index].item_group_name,
                parent_item_group: groups[index].parent_item_group,
                cover: config.baseUrl + groups[index].image,
                colors: ["#00AB55"],
            }));

            const groupedItems = _.groupBy(
                convertedGroups,
                "parent_item_group"
            );

            return groupedItems;
        },
        {
            onSuccess,
            onError,
            enabled: true,
        }
    );
};

const fetchSubGroups = (parentItem) => {
    let params = {
        fields: JSON.stringify(docTypeFields.ItemGroup),
        filters: JSON.stringify({ parent_item_group: parentItem }),
        limit: 0, // Set the limit to 0 to load all items
    };
    return axios.get(`/resource/Item Group`, { params });
};

export const useSubGroups = (parentItem, onSuccess, onError) => {
    return useQuery(
        ["getGroupSubGroups", parentItem],
        async () => {
            const data = await fetchSubGroups(parentItem);

            const groups = _.remove(data.data.data, function (element) {
                return element.showpos === 1;
            });

            const convertedGroups = [...groups]
                .map((_, index) => ({
                    id: groups[index].item_group_name,
                    name: groups[index].item_group_name,
                    cover: config.baseUrl + groups[index].image,
                    colors: ["#00AB55"],
                }))
                .slice(0, 8);

            return convertedGroups;
        },
        {
            // select: transformGroups,
            onSuccess,
            onError,
            enabled: !!parentItem,
        }
    );
};
